@let isIdCaptureRequired = this.isIdCaptureRequired();

<div class="landing-page">
  <app-info-bar></app-info-bar>
  @if (isLoaded()) {
    <div class="landing-page__content">
      <h1 class="nova-heading-large">
        {{ "landing-page.WELCOME" | translate: { name: firstName() } }}
      </h1>

      @if (isIdCaptureRequired) {
        <p class="landing-page__subtitle nova-body-large">
          {{ "landing-page.SUBHEADING" | translate }}
        </p>
      }

      <div class="esign-card card-content">
        <div class="instructions">
          <h2 class="instructions__heading nova-heading-xxsmall">
            {{
              `landing-page.CARDHEADING${isIdCaptureRequired ? "-WITHID" : ""}`
                | translate
            }}
          </h2>

          @if (isIdCaptureRequired) {
            <ul class="instructions__list nova-body-large">
              <li>
                <nova-icon name="lightbulb" size="small" />{{
                  "landing-page.PHOTOCAPTURE-TIPLIGHTING" | translate
                }}
              </li>
              <li>
                <nova-icon name="photo_camera" size="small" />{{
                  "landing-page.PHOTOCAPTURE-TIPCAMERA" | translate
                }}
              </li>
              <li>
                <nova-icon name="security" size="small" />{{
                  "landing-page.PHOTOCAPTURE-TIPSECURE" | translate
                }}
              </li>
            </ul>
          } @else {
            <p class="instructions__description nova-body-large">
              {{ "landing-page.SUBHEADING" | translate }}
            </p>
          }
        </div>

        <ng-container *ngTemplateOutlet="actionButtons"></ng-container>

        <app-legal-acknowledgement-footer
          [buttonText]="'landing-page.BUTTONTEXT' | translate"
        ></app-legal-acknowledgement-footer>
      </div>
    </div>
  }
</div>

@if (isLoaded()) {
  <div class="esign-action-footer">
    <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
  </div>
}

<ng-template #actionButtons>
  <button
    novaButton
    appTrackedButton
    [trackId]="'landing-page:start'"
    [trackType]="'continue'"
    (click)="navigateToNextStep()"
  >
    {{ "landing-page.BUTTONTEXT" | translate }}
  </button>
</ng-template>
